export default __webpack_public_path__ + "static/leaddev_advent_calendar-91a79d98c119fb5bd7ed9859471d9b72.png";